module.exports = __webpack_public_path__ + "static/media/sample_bulk_coil_force_close.412ef870.csv";